import {updateFactory} from '@modifi/redux'
import {
  PatchPersonIdentificationRequestView,
  getAuthenticatedThemisClient,
} from '@modifi/onboarding-api-clients'
import {PersonLegalRoleVal} from '@modifi/enums'
import {pickPropertyKeysByLegalRole} from '../utils'
import {NestedError} from '../../../utils'

const apiClient = getAuthenticatedThemisClient()

const {actions} = updateFactory({
  rootSelector: state => state?.modules?.legalRoles?.update,
  actionNamePrefix: 'modules/legal-roles/update',
  submitRequest:
    (
      a,
      externalPersonId: string,
      legalRole: PersonLegalRoleVal,
      data: PatchPersonIdentificationRequestView
    ) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      try {
        const roleSpecificChanges = pickPropertyKeysByLegalRole(legalRole, data)

        await apiClient.Person.linkUpdate({
          externalPersonId,
          legalRole,
          body: roleSpecificChanges,
        }).then(res => res.data())

        dispatch(a.successAction())
      } catch (error: any) {
        dispatch(a.errorAction(error))
        throw new NestedError(`Error while calling Person.link endpoint`, error)
      }
    },
})

export const {aSubmit: aUpdatePersonToLegalRoleLink} = actions
